<template>
  <div class="card-viewer" 
    ref="viewerRef" 
    :class="{
      'expand': isExpand,
      'mobile': isMobile,
      'fixed': isFixed,
      'custom': fill || cover,
    }"
  >
    <div 
      :class="[cardClassName, 'card-content']" 
      :style="{
        backgroundColor: fill || '',
        color: color || '',
      }"
      :data-card-layout="cardLayout"
      @click="() => !isMobile ? expand() : isOpenViewer = true"
    >
      <template v-if="cover">
        <div class="card-cover" :style="{ backgroundImage: cover ? `url(${cover})` : '' }"></div>
        <div class="card-text">
          <div class="icon" v-if="icon" v-html="icon"></div>{{ text }}
        </div>
      </template>
      <template v-else>
        <div class="icon" v-if="icon" v-html="icon"></div>{{ text }}
      </template>

      <div class="expand-btn">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1em" height="1em" viewBox="0 0 1024 1024"><path d="M1016.09912342 36.38631795a18.1744954 18.1744954 0 0 0-1.0520692-3.55073355 30.58891194 30.58891194 0 0 0-1.31508649-4.2082768 40.8991901 40.8991901 0 0 0-2.23564705-4.07676814 24.38170367 24.38170367 0 0 0-1.70961244-3.15620759 39.57095273 39.57095273 0 0 0-11.70426984-11.70426983c-0.92056056-0.65754325-2.1041384-1.18357785-3.02469894-1.70961246l-4.2082768-2.76168164a37.4405126 37.4405126 0 0 0-4.20827679 0l-3.9452595-1.8411211a43.87128559 43.87128559 0 0 0-8.28504493-0.78905189H722.25619627a42.08276794 42.08276794 0 0 0 0 84.16553587h150.84042135L566.33954106 393.6953195a42.08276794 42.08276794 0 1 0 59.44190972 59.44190971L932.67003598 146.3275492V297.16797052a42.08276794 42.08276794 0 0 0 84.16553589 0V44.67136287a43.87128559 43.87128559 0 0 0-0.78905191-8.28504492z m-618.09065412 525.6400733L91.01467717 868.83607126V717.99564993a42.08276794 42.08276794 0 0 0-84.16553587 0v252.49660764a43.6740226 43.6740226 0 0 0 0.78905189 8.28504495 18.1744954 18.1744954 0 0 0 1.0520692 3.55073354 30.58891194 30.58891194 0 0 0 1.3150865 4.2082768 40.8991901 40.8991901 0 0 0 2.23564704 4.07676814 23.55319919 23.55319919 0 0 0 1.70961247 3.1562076 38.2295645 38.2295645 0 0 0 11.70426982 11.70426983 24.38170367 24.38170367 0 0 0 3.15620759 1.70961244 40.8991901 40.8991901 0 0 0 4.07676815 2.23564705l4.20827678 1.31508651 3.55073355 1.05206919a43.87128559 43.87128559 0 0 0 8.28504494 0.7890519h252.49660765a42.08276794 42.08276794 0 0 0 0-84.16553588H150.640699l306.80968001-306.94118868a42.08276794 42.08276794 0 0 0-59.44190971-59.44190971z m0 0"></path></svg>
        <span class="text">展开</span>
      </div>
    </div>

    <template v-if="isExpand">
      <div class="viewer-btns">
        <div class="item" @click="isExpand = false" v-tooltip="{ content: '折叠', placement: 'right' }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1em" height="1em" viewBox="0 0 1027 1024">
            <path d="M566.94342148 444.98596316A43.44482181 43.44482181 0 0 0 597.81272866 457.80805652h235.412225a43.83230266 43.83230266 0 0 0 0-87.65286347H714.2683348l286.50098711-286.5009871a43.90275372 43.90275372 0 0 0-31.09240222-74.76031905h-0.07045106a43.3039197 43.3039197 0 0 0-30.81059796 12.77512599l-297.06864646 297.06864645V178.64572175a43.83230266 43.83230266 0 0 0-87.65286345 0v235.37699949a43.15127571 43.15127571 0 0 0 12.86906072 30.96324192zM80.73715618 1003.65114616l286.50098709-286.5009871v118.96836071a43.83230266 43.83230266 0 0 0 87.65286346 0V600.75326213a43.87927002 43.87927002 0 0 0-43.77359343-43.79707712H175.70518828a43.83230266 43.83230266 0 0 0 0 87.66460532h140.08019574l-297.06864644 297.06864645a43.83230266 43.83230266 0 0 0 62.00867675 61.97345121z"></path>
          </svg>
        </div>
        <div class="item" @click="isOpenViewer = true" v-tooltip="{ content: '全屏', placement: 'right' }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1em" height="1em" viewBox="0 0 1027 1024"><path d="M730.08759613 8l114.61507214 114.41835563-222.86498161 222.86498062 56.16236882 56.1764198 222.92118549-222.90713353 118.73205323 118.53533671V8H730.08759613zM686.73985845 618.17034247l-56.17641881 56.1764198 220.72920877 220.72920876-120.72731344 120.92402897h289.08795923V726.43430291l-112.22637989 112.42309443-220.68705586-220.68705487zM340.91343477 405.82965753l56.17641979-56.1764198L176.3606458 128.92402897 297.08795923 8H8v289.56569709l112.24043086-112.42309443 220.67300391 220.68705487zM349.65323773 622.54024395L126.73205323 845.46142944 8 726.91204077v289.08795923h289.56569709l-114.60102018-114.41835563 222.86498062-222.86498062-56.1764198-56.1764198z"></path></svg>
        </div>
      </div>
      <template v-if="!isOpenViewer">
        <slot></slot>
      </template>
    </template>

    <div class="card-viewer-fullscreen" :class="{ 'mobile': isMobile }" v-if="isOpenViewer">
      <div class="viewer-mask" @click="isOpenViewer = false; isExpand = false; isFixed = false;">
        <div class="viewer-close-btn">
          <svg viewBox="0 0 1024 1024" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
            <path d="M578.36284173 512l422.30899284-422.30899284c18.09895683-18.09895683 18.09895683-48.2638849 0-66.36284173-18.09895683-18.09895683-48.2638849-18.09895683-66.36284173 0l-422.30899284 422.30899284-422.30899284-422.30899284c-18.09895683-18.09895683-48.2638849-18.09895683-66.36284173 0-18.09895683 18.09895683-18.09895683 48.2638849 0 66.36284173l422.30899284 422.30899284-422.30899284 422.30899284c-18.09895683 18.09895683-18.09895683 48.2638849 0 66.36284173 18.09895683 18.09895683 48.2638849 18.09895683 66.36284173 0l422.30899284-422.30899284 422.30899284 422.30899284c18.09895683 18.09895683 48.2638849 18.09895683 66.36284173 0 18.09895683-18.09895683 18.09895683-48.2638849 0-66.36284173l-422.30899284-422.30899284z"></path>
          </svg>
        </div>
      </div>
      <div class="viewer-container" :style="viewerContainerStyles">
        <slot name="fullscreen"></slot>
      </div>
    </div>

    <div class="card-viewer-fixed" v-if="isFixed && !isOpenViewer">
      <div class="fixed-content">
        <div class="viewer-btns">
          <div class="item" @click="isFixed = false" v-tooltip="{ content: '折叠', placement: 'right' }">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1em" height="1em" viewBox="0 0 1027 1024">
              <path d="M566.94342148 444.98596316A43.44482181 43.44482181 0 0 0 597.81272866 457.80805652h235.412225a43.83230266 43.83230266 0 0 0 0-87.65286347H714.2683348l286.50098711-286.5009871a43.90275372 43.90275372 0 0 0-31.09240222-74.76031905h-0.07045106a43.3039197 43.3039197 0 0 0-30.81059796 12.77512599l-297.06864646 297.06864645V178.64572175a43.83230266 43.83230266 0 0 0-87.65286345 0v235.37699949a43.15127571 43.15127571 0 0 0 12.86906072 30.96324192zM80.73715618 1003.65114616l286.50098709-286.5009871v118.96836071a43.83230266 43.83230266 0 0 0 87.65286346 0V600.75326213a43.87927002 43.87927002 0 0 0-43.77359343-43.79707712H175.70518828a43.83230266 43.83230266 0 0 0 0 87.66460532h140.08019574l-297.06864644 297.06864645a43.83230266 43.83230266 0 0 0 62.00867675 61.97345121z"></path>
            </svg>
          </div>
          <div class="item" @click="isOpenViewer = true" v-tooltip="{ content: '全屏', placement: 'right' }">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="1em" height="1em" viewBox="0 0 1027 1024"><path d="M730.08759613 8l114.61507214 114.41835563-222.86498161 222.86498062 56.16236882 56.1764198 222.92118549-222.90713353 118.73205323 118.53533671V8H730.08759613zM686.73985845 618.17034247l-56.17641881 56.1764198 220.72920877 220.72920876-120.72731344 120.92402897h289.08795923V726.43430291l-112.22637989 112.42309443-220.68705586-220.68705487zM340.91343477 405.82965753l56.17641979-56.1764198L176.3606458 128.92402897 297.08795923 8H8v289.56569709l112.24043086-112.42309443 220.67300391 220.68705487zM349.65323773 622.54024395L126.73205323 845.46142944 8 726.91204077v289.08795923h289.56569709l-114.60102018-114.41835563 222.86498062-222.86498062-56.1764198-56.1764198z"></path></svg>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '../utils/tooltip'

const isMobile = () => {
  return navigator.userAgent.match(/(iPhone|iPod|iPad|Android|Mobile|BlackBerry|Symbian|Windows Phone)/i)
}

export default {
  name: 'card-viewer',
  directives: {
    tooltip: Tooltip
  },
  props: {
    isFullscreen: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    cardClassName: {
      type: String,
      default: '',
    },
    fill: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    cover: {
      type: String,
      default: '',
    },
    cardLayout: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobileDevice: false,
      isOpenViewer: false,
      isExpand: false,
      isFixed: false,
      wrapWidth: 1000,
    }
  },
  computed: {
    isMobile() {
      return this.isMobileDevice || this.wrapWidth < 800
    },
    viewerContainerStyles() {
      // if(this.isMobile) {
      //   if(this.isFullscreen) {
      //     let w = document.body.clientWidth
      //     let h = document.body.clientHeight

      //     const wrapRef = document.querySelector('.mobile-preview-content')

      //     if(wrapRef) {
      //       w = wrapRef.clientWidth
      //       h = wrapRef.clientHeight
      //     }

      //     return {
      //       width: (h - 60) + 'px',
      //       height: (w - 60) + 'px',
      //       left: (w - (h - 60)) / 2 + 'px',
      //       top: (h - (w - 60)) / 2 + 'px',
      //       transform: 'rotate(90deg)',
      //     }
      //   }
      // }

      return {
        width: 'calc(100% - 60px)',
        height: 'calc(100% - 60px)',
        left: '30px',
        top: '30px',
      }
    },
  },
  watch: {
    isExpand() {
      if(this.isExpand) {
        this.$nextTick(() => this.$emit('open'))
      }
    },
    isOpenViewer() {
      if(this.isOpenViewer) {
        this.$nextTick(() => this.$emit('open'))
      }
    },
  },
  mounted() {
    this.isMobileDevice = isMobile()
    
    const wrapRef = document.querySelector('.render-content')
    const updateWrapWidth = () => this.wrapWidth = wrapRef.clientWidth
    updateWrapWidth()

    const resizeObserver = new ResizeObserver(updateWrapWidth)
    resizeObserver.observe(wrapRef)
  },
  methods: {
    expand() {
      const viewerRef = this.$refs.viewerRef
      const groupParent = viewerRef.closest('.column-group-view')

      if(groupParent) this.isFixed = true
      else this.isExpand = true

      this.$nextTick(() => {
        const rect = viewerRef.getBoundingClientRect()
        const height = document.body.clientHeight
        
        if((height - 50) - rect.height > 0) {
          const diff = rect.top - (height - rect.height) / 2
          const containerRef = document.querySelector('.scroll-box')
          containerRef.scrollTop = containerRef.scrollTop + diff
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-viewer {
  margin: -12px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, .08);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -1px rgba(0, 0, 0, .06);

  &:not(.expand, .mobile, .fixed) {
    transition: background-color .15s, transform .15s;

    &:hover {
      transform: scale(1.03);
      background-color: inherit;
    }
    &:not(.custom):hover {
      background-color: #fededf;
    }
  }

  .viewer-btns {
    display: none;
    position: absolute;
    right: -40px;
    top: 0;

    .item {
      width: 30px;
      height: 30px;
      box-shadow: 0 0 3px rgba(80, 80, 80, .25);
      background-color: #f5f5f5;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #999;
      font-size: 18px;
      cursor: pointer;

      &:hover {
        background-color: #fededf;
        transition: background-color .15s;
      }

      & + .item {
        margin-top: 10px;
      }
    }
    svg {
      color: #666;
    }
  }

  .card-viewer-fixed {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fixed-content {
    width: 1100px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .08);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -1px rgba(0, 0, 0, .06);
    border-radius: 10px;
    position: relative;

    &::before {
      content: '';
      width: 28px;
      height: 28px;
      border: 2px solid #e86b99;
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-radius: 50%;
      animation: app-loading .75s linear infinite;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -14px;
      margin-top: -14px;
    }

    .viewer-btns {
      display: block;
    }
  }

  &.expand {
    background-color: #fff;
    position: relative;
    margin: -12px -132px;

    &::before {
      content: '';
      width: 28px;
      height: 28px;
      border: 2px solid #e86b99;
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-radius: 50%;
      animation: app-loading .75s linear infinite;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -14px;
      margin-top: -14px;
    }

    .card-content {
      display: none;
    }
    .viewer-btns {
      display: block;
    }
  }

  .card-content {
    width: 100%;
    height: 108px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    color: #333;
    line-height: 1.375;
    border-radius: 10px;
    overflow: hidden;

    .icon {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    &:hover {
      .expand-btn {
        width: 70px;
        transition: width .15s;

        .text {
          display: block;
          margin-left: 10px;
        }
      }
    }

    .expand-btn {
      width: 28px;
      height: 28px;
      position: absolute;
      top: 8px;
      right: 8px;
      border: 1px solid #e1e1e1;
      background-color: rgba($color: #f5f5f5, $alpha: .3);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      cursor: pointer;

      .text {
        display: none;
        word-break: keep-all;
      }
      
      svg {
        font-size: 14px;
        color: inherit;
        margin-right: 0;
        margin-left: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.card-viewer-fullscreen {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;

  .viewer-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, .45);
  }
  .viewer-close-btn {
    width: 80px;
    height: 80px;
    background-color: rgba(0, 0, 0, .6);
    border-radius: 50%;
    position: absolute;
    right: -40px;
    top: -40px;
    cursor: pointer;

    svg {
      position: absolute;
      bottom: 18px;
      left: 18px;
      font-size: 13px;
      color: #fff;
    }
  }
  .viewer-container {
    position: absolute;
    z-index: 10;
    border-radius: 10px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);

    &::before {
      content: '';
      width: 42px;
      height: 42px;
      border: 3px solid #e86b99;
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-radius: 50%;
      animation: app-loading .75s linear infinite;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -21px;
      margin-top: -21px;
    }

    iframe, video {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 1;
    }
  }
}

@keyframes app-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>